(() => {
  if (window.atelierFilmRefinementLoaded) return;
  window.atelierFilmRefinementLoaded = true;
  const controllers = new WeakMap();
  const framesWithin = (root) => [
    ...(root.matches?.('[data-atelier-film]') ? [root] : []),
    ...root.querySelectorAll('[data-atelier-film]')
  ];
  const initialize = (root = document) => {
    framesWithin(root).forEach((frame) => {
      if (controllers.has(frame)) return;
      const video = frame.querySelector('video');
      const status = frame.querySelector('[data-film-status]');
      const text = frame.querySelector('[data-film-status-text]');
      const sound = frame.querySelector('[data-film-sound]');
      const soundText = frame.querySelector('[data-film-sound-text]');
      if (!video || !status || !text) return;
      frame.dataset.filmBound = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cleanup = [];
      const listen = (target, name, handler) => {
        target.addEventListener(name, handler);
        cleanup.push(() => target.removeEventListener(name, handler));
      };
      const nativeControls = video.controls;
      const playback = document.createElement('button');
      const isArabic = document.documentElement.lang.startsWith('ar');
      playback.type = 'button';
      playback.className = 'atelier-film__playback';
      playback.setAttribute('data-film-playback', '');
      const syncPlayback = () => {
        playback.setAttribute('aria-label', video.paused
          ? (isArabic ? 'تشغيل الفيديو' : 'Play video')
          : (isArabic ? 'إيقاف الفيديو مؤقتًا' : 'Pause video'));
      };
      frame.append(playback);
      video.controls = false;
      const state = (value) => {
        frame.dataset.filmState = value;
        status.hidden = value !== 'loading' && value !== 'error';
        text.textContent = value === 'error' ? frame.dataset.filmError : frame.dataset.filmLoading;
        syncPlayback();
      };
      const syncSound = () => {
        if (!sound || !soundText) return;
        const audible = !video.muted;
        const label = audible ? frame.dataset.filmMuteSound : frame.dataset.filmEnableSound;
        sound.setAttribute('aria-pressed', String(audible));
        sound.setAttribute('aria-label', label);
        soundText.textContent = label;
      };
      const playFailure = (error) => {
        if (!frame.isConnected) return;
        if (error?.name === 'NotAllowedError' || error?.name === 'AbortError') state('paused');
        else state('error');
      };
      const requestPlay = () => {
        try { video.play()?.catch(playFailure); }
        catch (error) { playFailure(error); }
      };
      listen(playback, 'click', () => {
        if (video.paused) requestPlay();
        else video.pause();
      });
      listen(video, 'loadstart', () => { if (!video.paused) state('loading'); });
      listen(video, 'play', () => state(video.readyState < 3 ? 'loading' : 'ready'));
      listen(video, 'waiting', () => { if (!video.paused) state('loading'); });
      listen(video, 'loadeddata', () => state('ready'));
      listen(video, 'canplay', () => state('ready'));
      listen(video, 'playing', () => state('playing'));
      listen(video, 'pause', () => state('paused'));
      listen(video, 'ended', () => state('ended'));
      listen(video, 'error', () => state('error'));
      listen(video, 'volumechange', syncSound);
      if (sound && soundText) {
        sound.hidden = false;
        listen(sound, 'click', () => {
          video.muted = !video.muted;
          syncSound();
          if (video.paused) requestPlay();
        });
      }
      const reduceMotion = (event) => {
        if (!event.matches) return;
        video.autoplay = false;
        video.pause();
        state('paused');
      };
      listen(reduced, 'change', reduceMotion);
      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      video.autoplay = !reduced.matches;
      syncSound();
      state(video.error ? 'error' : 'idle');
      if (reduced.matches) {
        video.pause();
        state('paused');
      } else if (!video.error) requestPlay();
      controllers.set(frame, () => {
        cleanup.forEach(remove => remove());
        playback.remove();
        video.controls = nativeControls;
        video.pause();
        delete frame.dataset.filmBound;
        controllers.delete(frame);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    framesWithin(event.target).forEach(frame => controllers.get(frame)?.());
  });
})();
